import { render, staticRenderFns } from "./OrderResult.vue?vue&type=template&id=5552686c&scoped=true&"
import script from "./OrderResult.vue?vue&type=script&lang=js&"
export * from "./OrderResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5552686c",
  null
  
)

export default component.exports